export default __webpack_public_path__ + "static/media/CommonInternetWhalingAttacks3.e475ece2.png";